import environment from './environment';

export const getHost = () => {
  let host = window.location.host;

  if (environment.VITE_ENVIRONMENT === 'local') {
    host = 'http://' + host;
  } else {
    host = 'https://' + host;
  }

  return host;
};
